import { Button } from '@/components/Button';
import { ChevronLeft } from '@/components/Icons';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

const baseButtonStyling =
  'text-gray bg-gray-100 size-8 items-center justify-center font-[900] text-sm';

const disabledButtonStyling = 'cursor-default text-gray-300 hover:shadow-none';

type TablePaginationProps = {
  totalItems: number;
  pageIndex: number;
  totalPages: number;
  nextDisabled: boolean;
  visiblePages?: number;
  prevDisabled: boolean;
  onPageChange: (page: number) => void;
  onNextPage: () => void;
  onPrevPage: () => void;
};

export const TablePagination = ({
  pageIndex,
  nextDisabled,
  prevDisabled,
  totalPages,
  onPrevPage,
  onPageChange,
  onNextPage,
}: TablePaginationProps): ReactElement => {
  const startPage = 0;

  const pages = Array.from(
    { length: totalPages - startPage },
    (_, i) => i + startPage,
  );

  return (
    <div className="flex w-full justify-center gap-[5px]">
      <Button
        className={twMerge(
          baseButtonStyling,
          prevDisabled && disabledButtonStyling,
        )}
        onClick={onPrevPage}
      >
        <ChevronLeft />
      </Button>
      {pages.map((page) => {
        return (
          <Button
            className={twMerge(
              baseButtonStyling,
              pageIndex === page ? 'bg-gray text-white' : '',
            )}
            key={page}
            onClick={() => onPageChange(page)}
          >
            {page + 1}
          </Button>
        );
      })}
      <Button
        className={twMerge(
          baseButtonStyling,
          nextDisabled && disabledButtonStyling,
        )}
        onClick={onNextPage}
      >
        <ChevronLeft className="w-min rotate-180 transform" />
      </Button>
    </div>
  );
};
